import * as Sentry from '@sentry/react'
import { useEffect } from 'react'
import { useRouteError } from 'react-router'
import { t } from 'i18next'
import { Button } from './ui/button'
import { ErrorState } from './ErrorState'

function toError(error: unknown): Error {
  if (error instanceof Error) {
    return error
  }
  return new Error(typeof error === 'string' ? error : JSON.stringify(error))
}

export const ErrorRoute = () => {
  const error = useRouteError()
  const parsedError = toError(error)

  useEffect(() => {
    Sentry.captureException(parsedError, {
      tags: { area: 'route-error' },
    })
  }, [parsedError])

  return (
    <ErrorState>
      <h2>{t('error.title')}</h2>
      <span className="text-muted-foreground break-words">{parsedError.message}</span>
      <Button type="button" variant="outline" onClick={() => window.location.reload()}>
        {t('error.tryAgain')}
      </Button>
    </ErrorState>
  )
}
